/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_No_Target_FolderInputs */



/**
* | output |
* | --- |
* | "No destination folder selected." |
*
* @param {Explorer_Info_Batch_No_Target_FolderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_no_target_folder = /** @type {((inputs?: Explorer_Info_Batch_No_Target_FolderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_No_Target_FolderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun dossier de destination sélectionné.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Zielordner ausgewählt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna cartella di destinazione selezionata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Папка назначения не выбрана.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se seleccionó ninguna carpeta de destino.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择目标文件夹。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存先フォルダが選択されていません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई गंतव्य फ़ोल्डर चयनित नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma pasta de destino selecionada.")
	return /** @type {LocalizedString} */ ("No destination folder selected.")
});